import React from 'react';
import { useTranslation } from 'react-i18next';
import Button from '@material-ui/core/Button';
import Divider from '@material-ui/core/Divider';

export const LanguageBox = ({isMenuItem}) => {
  const { i18n } = useTranslation();

  const changeLanguage = code => {
    i18n.changeLanguage(code);
  };
  
  return (
    <div>
      <Button onClick={() => changeLanguage('en')}>
        EN
      </Button>
      <Divider />
      <Button onClick={() => changeLanguage('es')}>
        ES
      </Button>
    </div>
  )
}